import { actions }  from "../../actions/common/sectors";

export default function sectors ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case actions.SET_SECTORS:
            return setSectors( newState, action.sectors );
        default: return newState;
    }
}

function setSectors ( newState, sectors ) {
    newState.sectors = sectors;

    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/common/sectors.js